"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findFirstRealSample = exports.getSampleId = exports.findSelectedSample = exports.wasSkipped = void 0;
function wasSkipped(sample) {
    return sample._zap_data_was_skipped;
}
exports.wasSkipped = wasSkipped;
function findSelectedSample({ samples, selectedSampleId, }) {
    return samples.find(sample => getSampleId(sample) === selectedSampleId);
}
exports.findSelectedSample = findSelectedSample;
function getSampleId(sample) {
    return sample._zap_data_sample_id;
}
exports.getSampleId = getSampleId;
function findFirstRealSample(samples) {
    return samples.find(sample => !wasSkipped(sample));
}
exports.findFirstRealSample = findFirstRealSample;
